//
import SalarySettlementModel from '@/models/HumanResource/HrSalarySettlement'
//
import SalarySettlementIncludes from './SalarySettlementIncludes'

const fetchByPeriod = async (year, month) => {
    //
    try {
        //
        const response = await SalarySettlementModel.include(SalarySettlementIncludes)
            .params({ get_all_results: true })
            .where( 'can_be_added_to_payroll', 1)
            .where( 'period_year', year )
            .where( 'period_month', month )
            .get()
        //
        return response.data
    } catch (error) {
        //
        return error.response.data
    }
}

export default fetchByPeriod
